<template>

  <div elevation="3" :disabled="disable" :class="{ pasifCard: disable }">
    <div v-if="disable" style="background: white;"><span style="color: red;">Bu öğe pasif olduğundan başvuru ekranında
        görüntülenmeyecektir. </span></div>
    <p class="ma-0">
      <strong style="color: black;" v-html="label"> </strong> <strong v-if="required"
        style="color: red;margin:0px 5px;">*</strong>
    </p>
    <v-file-input :hint="hint" clearable :persistent-hint="true"  :accept="acceptComp" outlined show-size
      v-bind="ekProp" :rules="validationRules" v-model="value"></v-file-input>
    Dosya boyutu {{ size }} MB({{ size * 1024 }} KB)'dan fazla olamaz.
    <!-- <ul>
      <li v-for="(item, index) in belges" :key="item"><a :href="'../' + item">Dosya_{{ index + 1 }}</a></li>
    </ul>
    Deneme -->
    <div v-if="edit">
      <ul>
        <li v-for="(item, index) in belgelistesi" :key="item"><a :href="'../' + item">Dosya_{{ index + 1 }}</a></li>
      </ul>
    </div>


  </div>

  <!-- <v-card elevation="3" :disabled="disable" :class="{ pasifCard: disable }" >
       
    <v-card-text>

    </v-card-text>
  </v-card> -->



</template>
<script>
import { fileSF } from '@/plugins/FieldDataFormat.js'
import { FileExtensions, FileTypes } from '@/plugins/FileExtensions.js'
import { rules, CustomFunc } from '@/plugins/custom.js'

export default {
  data() {
    return {
initialBelgeList: "",
      belges: [],
      value: null,
      label: "",
      accept: [],
      size: 5,
      required: false,
      hint: "",
      disable: false,
      multi: false,
      cols: 12,
      incols: 12,
      rules: [v => !!v || 'Name is required'],


    }
  },
  props: {
    ayar: {
      // default: '{"title":"","description":""}',
      default() {
        return fileSF;
      },
      type: Object
    },
    edit: {
      // default: '{"title":"","description":""}',
      default() {
        return false;
      },
      type: Boolean
    },


  },
  methods: {
    formatSize(bytes) {
      if (bytes < 1024) return `${bytes} B`;
      else if (bytes < 1024 * 1024) return `${(bytes / 1024).toFixed(1)} KB`;
      else return `${(bytes / (1024 * 1024)).toFixed(1)} MB`;
    },
    dataBind(json) {
      // console.log("Vtext Json", json);
      // let ayarJson = JSON.parse(jsonStr);
      if (typeof json.value === 'string') {
        this.initialBelgeList = json.value;
      }
    if (!(this.value instanceof File) && !Array.isArray(this.value)) {
    this.value = null;
  }
      this.title = json.title;

      this.rules = json.rules;
      this.hint = json.hint;
      this.label = json.label;
      this.accept = json.accept;
      this.size = json.size;
      this.multi = json.multi;
      this.required = json.required;
      this.disable = json.disable;
    }
  },
  computed: {
    belgelistesi() {
      //return this.ayar.value?.split(',') ?? [];
      return this.initialBelgeList ? this.initialBelgeList.split(',') : [];
    },
    acceptComp() {
      let acceptList = this.accept.map(m => FileExtensions[m].accept).join();
      // console.log("accepList:", acceptList);
      return acceptList;

    },

    ekProp() {
      // console.log("object,");
      if (this.multi) {
        return { multiple: true }
      }
      else {
        return '';
      }

    },
    maxBytes() {
      return this.size ? this.size * 1024 * 1024 : null;
    },
    getComponentName() {
      return this.rules.map(m => rules[m]);

    },
    validationRules() {
      return [
        v => {
          // required kontrolü
          if (this.required && !v && !this.edit) {
            return "Bu alan zorunludur";
          }
          return true;
        },
        v => {
          if (!v) return true;
          // if (typeof myVar === 'string' || myVar instanceof String)

          const files = Array.isArray(v) ? v : [v];

          // Boyut kontrolü
          if (this.maxBytes) {
            const oversized = files.some(file => file.size > this.maxBytes);
            if (oversized) {
              return `Dosya boyutu ${this.size} MB'den büyük olamaz`;
            }
          }

          // Uzantı kontrolü


          let acceptExtensionList = this.accept.map(m => FileExtensions[m].extensions).join(",");
          if (acceptExtensionList.length > 0) {
            const invalid = files.some(file => {
              const ext = file.name.split(".").pop().toLowerCase();
              console.log("Ext:", ext, "acceptExtensionList", acceptExtensionList);
              return !acceptExtensionList.includes(ext);
            });

            if (invalid) {
              return `Sadece şu uzantılar kabul edilir: ${acceptExtensionList}`;
            }
          }

          return true;
        }
      ];
    },

    getAyar: function () {

      return this.ayar;
    },


  },
  created() {
    /// this.dataBind(this.ayar);
    // if (this.ayar.value) {
    //   this.belges = this.ayar.value?.split(',') ?? [];
    //   // this.value = null;
    // }

  },
  watch: {
    ayar: {
      immediate: true,
      handler(newVal, oldVal) {
        this.dataBind(newVal);
      },
      deep: true
    },
    value(n, o) {
      // console.log("File", n);
      console.log("File:",n);
      this.$emit('input', n);

    },
  },

}
</script>
<style scoped>
.pasifCard {
  background-color: gray !important;
}
</style>